export const ADD_LOCATIONS = 'ADD_LOCATIONS';

export function addLocations(locations) {
    return { type: ADD_LOCATIONS, locations };
}

